import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PilotPayHttpClient } from '../../core';
import { IAircraftModel, AircraftModel } from './aircraft-models.types';
/**
 * AircraftModelsService
 */
@Injectable()
export class AircraftModelsService {
	constructor(http: PilotPayHttpClient) {
		this.http = http;
	}

	private http: PilotPayHttpClient;

	public getAircraftModels(): Observable<IAircraftModel[]> {
		return this.http.getRequest('/api/aircraft-models');
	}

	public getArchivedAircraftModels(): Observable<IAircraftModel[]> {
		return this.http.getRequest('/api/aircraft-models/archived');
	}

	public getAircraftModelById(id: string): Observable<IAircraftModel> {
		return this.http.getRequest(`/api/aircraft-models/${id}`);
	}

	public getArchivedAircraftModelById(id: string): Observable<IAircraftModel> {
		return this.http.getRequest(`/api/aircraft-models/archived/${id}`);
	}

	public addAircraftModel(aircraft: IAircraftModel): Observable<AircraftModel> {
		return this.http.postRequest('/api/aircraft-models', aircraft);
	}

	public deleteAircraftModel(id: string, endDate: string): Observable<any> {
		return this.http.deleteRequest(`/api/aircraft-models/${id}/${endDate}`);
	}

	public updateAircraftModel(aircraft: IAircraftModel): Observable<AircraftModel> {
		return this.http.putRequest(`/api/aircraft-models`, aircraft);
	}
}
